import { UserPatch } from "@infoland/iprova-api";
import { namespace as userNamespace } from "../modules/user/user";
import { Store } from "vuex";
import { OwnUserGetDto } from "@/api/OwnUserGetDto";

// most properties might be not determined (needs api-call)  except those passed from aspx back-end
export type MinimalUserInfo = Partial<OwnUserGetDto> & Required<Pick<OwnUserGetDto, "user_id" | "login_code" | "language" | "date_format">>;

export class UserStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the logged on user */
    public get loggedOnUser(): OwnUserGetDto {
        return this.store.getters[`${userNamespace}/loggedOnUser`];
    }

    /** Loads the logged on user */
    public getLoggedOnUser(reload: boolean = false): Promise<OwnUserGetDto> {
        if (reload !== true && this.loggedOnUser) return Promise.resolve(this.loggedOnUser);

        return this.store.dispatch(`${userNamespace}/loadLoggedOnUser`);
    }

    /** update the statistics of the current user */
    public async updateUserStatistics(): Promise<void> {
        return this.store.dispatch(`${userNamespace}/loadLoggedOnUser`);
    }

    public saveUserAsync(userId: string, userProps: Partial<UserPatch>): Promise<boolean | null> {
        return this.store.dispatch(`${userNamespace}/saveUserAsync`, { userId, userProps });
    }

    /** Update unread tasks property */
    public async updateUnreadTasksAmount(amount: number): Promise<void> {
        await this.store.dispatch(`${userNamespace}/updateUnreadTasksAmount`, { amount: amount });
    }

    /** Update unread notifications property */
    public async updateUnreadNotificationsAmount(amount: number): Promise<void> {
        await this.store.dispatch(`${userNamespace}/updateUnreadNotificationsAmount`, { amount: amount });
    }
}
